import React from 'react'
import useStyles from './PageContent.styles'

interface IProps {
  children: React.ReactNode
}

export const PageContent = ({ children }: IProps) => {
  const { classes } = useStyles()

  return <div className={classes.root}>{children}</div>
}
